'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useHasParentContext", {
    enumerable: true,
    get: function() {
        return useHasParentContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useHasParentContext(context) {
    const contextValue = _react.useContext(context);
    if (contextValue.version) {
        return contextValue.version.current !== -1;
    }
    return false;
}
